import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, CardTitle, Col, Row } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import _ from 'lodash';
import { ServiceThreadSpinner } from '.';
import { DesktopContainer } from '../layouts';
import { api, constants } from '../utils';

export default function CountMain() {
   const navigate = useNavigate();
   const [doneCounts, setDone] = useState({});
   const [editor, setEditor] = useState(false);
   const [loaded, setLoaded] = useState(false);
   const [openCounts, setOpen] = useState({});

   useEffect(() => {
      api.fetch(`Mobile/GetCounts`)
         .then(response => {
            if (response.data.success) {
               setOpen(response.data.openCounts);
               setDone(response.data.closedCounts);
               setEditor(response.data.canEdit);
            }
            else {
               toast.error(response.data.message);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
         })
         .finally(() => {
            setLoaded(true);
         })
   }, [])

   function deleteCount(countId, displayId) {
      confirmAlert({
         title: "Permanently Delete Count?",
         message: `This will permanently delete ${displayId}. Are you sure?`,
         buttons: [
            {
               label: "Ok",
               onClick: () => {
                  api
                     .post(`Mobile/DeleteCount/${countId}`)
                     .then((response) => {
                        if (response.data.success) {
                           setOpen(response.data.openCounts);
                           setDone(response.data.closedCounts);
                        } else {
                           toast.error(response.data.message);
                        }
                     })
                     .catch(api.catchHandler);
               },
            },
            {
               label: "Cancel",
            },
         ],
      });
   }

   function editCount(countId) {
      var nav = constants.ENDPOINTS.countScan + "/" + countId;
      navigate(nav);
   }

   function newCount() {
      var nav = constants.ENDPOINTS.createCount;
      navigate(nav);
   }

   return (
      <>
         <DesktopContainer screenName="Inventory Counts">
            <ServiceThreadSpinner on={!loaded}>
               {editor ?
                  <div>
                     <Row className="justify-content-center">
                        <Col xs="12">
                           <Button
                              title="new count"
                              className="shredButton w-100 btn-md my-3"
                              onClick={() => { newCount(); }}>
                              Create New Count
                           </Button>
                        </Col>
                     </Row>
                  </div>
                  : null
               }
               <br />
               {loaded && openCounts ?
                  <div>
                     <Row><Col><hr className="my-0" /></Col></Row>
                     <Row className="align-items-center my-1">
                        <Col className="h6 fw-bold" xs={12}>
                           Current Inventory Counts
                        </Col>
                     </Row>
                     {_.map(openCounts, (item, index) => {
                        return (
                           <div details={item} key={index} >
                              <Card className="py-0">
                                 <CardBody className={(index % 2 === 0) ? "mobileBlueBg py-1 px-2" : "mobileBlueBgAlt py-1 px-2"}>
                                    <CardTitle className={(index % 2 === 0) ? "mobileBlueBg py-1 px-2" : "mobileBlueBgAlt py-1 px-2"}>
                                       {item.name}
                                    </CardTitle>
                                    {item.id > 0 ?
                                       <Row className="justify-content-center">
                                          <Col xs="6">
                                             <Button
                                                children="OPEN"
                                                className="shredButton w-100 btn-sm"
                                                onClick={() => { editCount(item.id); }} />
                                          </Col>
                                          <Col xs="6">
                                             {editor ?
                                                <Button
                                                   children="DELETE"
                                                   className="btn w-100 btn-sm"
                                                   onClick={() => { deleteCount(item.id, item.name); }} />
                                                : null
                                             }
                                          </Col>
                                       </Row>
                                       : null
                                    }
                                 </CardBody>
                              </Card>
                           </div>
                        )
                     })}
                  </div>
                  : null
               }

               <br />
               {loaded && doneCounts ?
                  <div>
                     <Row><Col><hr className="my-0" /></Col></Row>
                     <Row className="align-items-center my-1">
                        <Col className="h6 fw-bold" xs={12}>
                           Completed Inventory Counts
                        </Col>
                     </Row>
                     {_.map(doneCounts, (itm, idx) => {
                        return (
                           <div details={itm} key={idx} >
                              <Card className="py-0">
                                 <CardBody className={(idx % 2 === 0) ? "mobileBlueBg py-1 px-2" : "mobileBlueBgAlt py-1 px-2"}>
                                    <CardTitle className={(idx % 2 === 0) ? "mobileBlueBg py-1 px-2" : "mobileBlueBgAlt py-1 px-2"}>
                                       {itm.name}
                                    </CardTitle>
                                    {itm.id > 0 ?
                                       <Row className="justify-content-center">
                                          <Col xs="6">
                                             <Button
                                                children="VIEW"
                                                className="btn w-100 btn-sm"
                                                onClick={() => { editCount(itm.id); }} />
                                          </Col>
                                          <Col xs="6"></Col>
                                       </Row>
                                       : null
                                    }
                                 </CardBody>
                              </Card>
                           </div>
                        )
                     })}
                  </div>
                  : null
               }

            </ServiceThreadSpinner>
         </DesktopContainer >
      </>
   );
}
